import React from "react";
const IconToggleOff = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <rect x="1" y="4" width="18" height="12" rx="6" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    <rect x="1" y="4" width="12" height="12" rx="6" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
  </svg>
);
export default IconToggleOff;
